// src/redux/sagas/rootSaga.js
import { all, fork } from 'redux-saga/effects';
import { watchTreatmentPlanActions } from './treatmentPlanSaga';
import { watchPatientsActions } from './patientsSaga';
import { watchAnalyticsActions } from './analyticsSaga';
import { authSaga } from './authSaga';
import { usersSaga } from './usersSaga';

export default function* rootSaga() {
  console.log('Root saga started');
  yield all([
    fork(watchTreatmentPlanActions),
    fork(watchPatientsActions),
    fork(watchAnalyticsActions),
    fork(authSaga),
    fork(usersSaga),
  ]);
}
